// extracted by mini-css-extract-plugin
export var discard = "_52-3";
export var muiTooltipTooltip = "_52-5";
export var notificationBar = "_52-2";
export var saveButtonHoverSlotWrapper = "_52-4";
export var show = "_52-1";
export var spacer = "_52-0";